<template>
  <section style="background-color: #FAFAFA;" :class="{ 'is-admin': route_query.is_admin }">
    <section class="activeinfo-box">
      <div class="container-1752">
        <div class="bread-bar df aic control-mask">
          <div class="li cup" @click="handleLink('/index/index')">{{ $t('首页') }}</div>
          <div class="li cup" @click="handleLink('/activity/index')">{{ $t('活动') }}</div>
          <div class="li active">{{ $t('详情') }}</div>
        </div>
        <div class="info-box df control-mask">
          <div class="left-box">
            <img :src="dataInfo.ta_thumb" alt />
          </div>
          <div class="right-box f1 df fdc over-h">
            <div class="df f1">
              <div class="l-box f1 over-h">
                <div class="title one-text">{{ dataInfo.ta_title }}</div>

                <div class="list-box">
                  <div class="li df">
                    <img src="@/assets/images/icon/icon1.png" width="17" alt />
                    <span>
                      {{ $t('开始时间') }}：
                      {{ dataInfo.ta_start_time }}
                    </span>
                  </div>
                  <div class="li df">
                    <img src="@/assets/images/icon/icon1.png" width="17" alt />
                    <span>
                      {{ $t('结束时间') }}：
                      {{ dataInfo.ta_end_time }}
                    </span>
                  </div>
                  <div class="li df over-h">
                    <img src="@/assets/images/icon/icon2.png" width="17" alt />
                    <span class="one-text">{{ $t('活动地址') }}：{{ dataInfo.ta_city_text }}</span>
                  </div>
                </div>

                <div class="avarat-box mt-15 df aic">
                  <div
                    v-for="(item, index) in dataInfo.sign_up_list"
                    :key="index"
                    @click="handleOpenperson(item)"
                  >
                    <el-avatar :size="18" :src="item.user_avatar_att_url" @error="handleImageError">
                      <img src="@/assets/images/avatar.png" alt />
                    </el-avatar>
                  </div>

                  <span class="fs-12 c-ae ml-8">
                    {{ dataInfo.have_sign_up == 10 && dataInfo.tpsn_status
                    ==
                    20 ?
                    $t('已报名') : '' }}
                  </span>
                </div>
              </div>
              <div class="r-box df fdc aife jcfe">
                <div class="code-box">
                  <img :src="dataInfo.url_code" alt />
                  <p class="fs-12 c-9 ta-c">{{ $t('扫码分享') }}</p>
                </div>
              </div>
            </div>

            <div class="tpsn_status_box">
              <div class v-if="dataInfo.is_have_sign_up == 10">
                <img
                  :src="require('@/assets/images/activity/tpsn_status_' + dataInfo.tpsn_status + '.png')"
                  v-if="!currLanguage"
                  alt
                />
                <img
                  :src="require('@/assets/images/activity_en/tpsn_status_' + dataInfo.tpsn_status + '.png')"
                  v-else
                  alt
                />
              </div>
            </div>

            <div class="b-box df fww aife jcsb mt-20">
              <!-- 分享 -->
              <div class="share-box df">

                <div class="avarat-box mt-15 df aic">
                  <div
                    v-for="(item, index) in dataInfo.sign_up_list"
                    :key="index"
                    @click="handleOpenperson(item)"
                  >
                    <el-avatar :size="18" :src="item.user_avatar_att_url" @error="handleImageError">
                      <img src="@/assets/images/avatar.png" alt />
                    </el-avatar>
                  </div>

                  <span class="fs-12 c-ae ml-8">
                    {{ dataInfo.have_sign_up == 10 && dataInfo.tpsn_status
                    ==
                    20 ?
                    $t('已报名') : '' }}
                  </span>
                </div>

                <div
                  class="cup"
                  :class="{ 'c-them': dataInfo.have_like == 10 }"
                  v-throttle="1000"
                  @click="handleGive"
                >
                  <span class="iconfont">
                    {{ dataInfo.have_like == 10 ? '&#xe656;' : '&#xe61b;'
                    }}
                  </span>
                  <span class="text">{{ dataInfo.ta_likes }}</span>
                </div>
                <div class>
                  <span class="iconfont">&#xe611;</span>
                  <span class="text">{{ dataInfo.ta_hits }}</span>
                </div>

                <div class="bdsharebuttonbox share-box">
                  <a
                    href="javascript:void(0)"
                    @click="handleSearch()"
                    class="bds_more"
                    :data-cmd="currentLanguage == 'cn' ? 'more' : ''"
                  >
                    <span class="iconfont">&#xe620;</span>
                    <span class="text">{{ $t('分享') }}</span>
                  </a>
                  <!-- 英文分享 -->
                  <div
                    class="sharewx-link"
                    style="position: absolute;"
                    v-if="currentLanguage != 'cn'"
                  >
                    <div class="bdsharebuttonbox df fdc">
                      <a href="#" class="bds_weixin" data-cmd="weixin" title="WeChat">WeChat</a>
                      <a href="#" class="bds_linkedin" data-cmd="linkedin" title="linkedin">LinkedIn</a>
                    </div>
                  </div>
                </div>

                <!-- <div class="cup">
                                <span class="iconfont">&#xe620;</span>
                                <span class="text">{{ $t('分享') }}</span>
                </div>-->

                <div
                  class="cup"
                  @click="handleCollection"
                  v-throttle="1000"
                  :class="{ 'c-them': dataInfo.have_collection == 10 }"
                >
                  <span class="iconfont">
                    {{ dataInfo.have_collection == 10 ? '&#xe616;' : '&#xe65e;'
                    }}
                  </span>
                  <span class="text">{{ $t('收藏') }}</span>
                </div>
              </div>
              <div class="f1 df jcfe aic">
                <!-- <el-button
                  type="primary"
                  v-throttle="1000"
                  class="btn1"
                  v-if="dataInfo.have_sign_up == 10"
                  @click="handleCancelSignUp"
                >
                  {{ $t('取消报名')
                  }}
                </el-button> -->

                <!--                            <el-button type="primary" class="btn1" v-throttle="1000"-->
                <!--                                v-else-if="dataInfo.have_sign_up == 20 && dataInfo.is_sign_up == 20"-->
                <!--                                @click="handleSignUp">-->
                <!--                                {{ $t('立即报名') }}-->
                <!--                            </el-button>-->
                <el-button
                  type="primary"
                  class="btn1"
                  v-throttle="1000"
                  v-if="timestamp > dataInfo.ta_sign_start_time && timestamp < dataInfo.ta_sign_end_time &&
                        (dataInfo.have_sign_up == 20 || (dataInfo.have_sign_up == 10 && dataInfo.tpsn_status === 30))"
                  @click="handleSignUp"
                >{{ $t('立即报名') }}</el-button>

                <!-- <el-button type="primary" class="btn2" @click="handleOpenQu">
                                <span>{{ $t('立即提问') }}</span>
                                <p class="tow-text">{{ $t('在本场活动提问') }}</p>
                </el-button>-->

                <div class="btn2 cup df fdc aic jcc ml-10" @click="handleOpenQu">
                  <span class="fs-14 lh-16">{{ $t('立即提问') }}</span>
                  <!-- <p class="fs-14 ta-c lh-14 mt-0 tow-text">{{ $t('在本场活动提问') }}</p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tabs df">
          <div class="list" :class="{ 'active': flog == 1 }" @click="flog = 1">{{ $t('活动邀请函') }}</div>
          <div class="list" :class="{ 'active': flog == 2 }" @click="flog = 2">{{ $t('活动总结') }}</div>
          <div class="list" :class="{ 'active': flog == 3 }" @click="flog = 3">{{ $t('资料下载') }}</div>
        </div>
        <div class="content-box">
          <!-- 邀请函 -->
          <template v-if="flog == 1">
            <invitation :data="dataInfo.ta_content"></invitation>
          </template>

          <!-- 活动总结 -->
          <template v-if="flog == 2">
            <summarys :data="dataInfo.ta_summary"></summarys>
            <!-- 活动总结 -->
            <!-- <div class="content-html" v-html="dataInfo.ta_content" v-if="dataInfo.ta_content"></div> -->
            <!-- <div class="null-data df fdc jcc aic">
              <img src="@/assets/images/empty_data.png" alt />
              <p>{{ $t('暂无资料') }}</p>
            </div> -->
          </template>
          <template v-if="flog == 3">
            <!-- 资料下载 -->
            <template v-if="dataInfo.ta_annex_arr.length > 0 && dataInfo.ta_is_public == 20">
              <div
                style="color: #666; padding: 10px; font-size: 14px; "
              >( {{ $t('报名成功后，才可下载资料') }} )</div>
            </template>
            <div class="df fww control-mask" v-if="dataInfo.ta_annex_arr.length > 0">
              <div v-for=" item  in  dataInfo.ta_annex_arr " class="downAnnex-list df aic">
                <div class="fn">
                  <img :src="getDoc(item.att_title)" style="width: 58px;max-height: 58px;" alt />
                </div>
                <div class="righ-box f1 over-h">
                  <div class="df jcsb" style="width: 100%;">
                    <div
                      class="title harmonyos one-text"
                      :title="item.att_title"
                    >{{ item.att_title }}</div>
                  </div>
                  <div class="size harmonyos df aic jcsb">
                    <span>{{ item.att_size }}kb</span>
                    <span>{{ $t('下载次数') }} ： {{ item.download_times }}</span>
                    <div class="btns fn">
                      {{ item.create_time }}
                      <template v-if="(dataInfo.have_sign_up == 10 && dataInfo.tpsn_status == 20) || dataInfo.ta_is_public == 10">
                        <a class="harmonyos fs-16" style="color:#0067D1;" @click.prevent="handleDownload(item)">
                          {{ $t('下载') }}
                        </a>
                      </template>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="null-data df fdc jcc aic" v-else>
              <img src="@/assets/images/empty_data.png" alt />
              <p>{{ $t('暂无资料') }}</p>
            </div>
          </template>
        </div>
      </div>
    </section>

    <!-- 问题研讨 -->
    <div class="discuss-box" v-if="!route_query.is_admin">
      <div class="container-1752">
        <discuss :id="userId" :data="discussData" :userinfo="userinfo"></discuss>
      </div>
    </div>

    <el-dialog
      :title="$t('回复')"
      :visible.sync="dialogVisible"
      width="886px"
      :before-close="closeDialog"
    >
      <div class="df reply-person mb-12">
        <span class="fn mr-16 c-9 fs-14">{{ $t('回复') }}</span>
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 10 }"
          :placeholder="$t('请输入您的回复')"
          v-model="form.taqa_content"
          ref="textareaRef"
        ></el-input>

      </div>

      <div class="languige-text harmonyos-text" v-if="userinfo.user_expert == 10">
        {{ $t('以实名身份发布') }}
        <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">
          <span class="iconfont">&#xe677;</span>
        </el-tooltip>
        <el-checkbox-group v-model="form.is_expert" style="display: inline-block;" class="ml-23">
          <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>
        </el-checkbox-group>
      </div>

      <span slot="footer" class="dialog-footer">

        <el-button @click="closeDialog" class="btn1">{{ $t('取消') }}</el-button>
        <el-button type="primary" class="btn2" @click="openLinkDialog">{{ $t('插入链接') }}</el-button>
        <el-button type="primary" class="btn2" @click="handleReplyLink">{{ $t('确定') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
        :visible.sync="dialogVisibleLink"
        :title="$t('请输入链接地址')"
        @close="handleCloseLink"
    >
      <el-input v-model="linkUrl" :placeholder="$t('请输入链接地址')" />
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleLink = false" class="btn1">{{ $t('取消') }}</el-button>
                <el-button type="primary" @click="insertLink" class="btn2">{{ $t('确认') }}</el-button>
            </span>
    </el-dialog>

    <!-- 个人信息 -->
    <avatarTop ref="avatarDialog" @post-submitted="handlePostSubmitted" :id="id" />
  </section>
</template>

<script>
// 邀请函
import invitation from "./components/invitation.vue";
// 活动总结
import summarys from "./components/summary.vue";
// 问题研讨
import discuss from "./components/discuss.vue";

import {
  getactivityInfo,
  getdownloaddownAnnex,
  setSignUp,
  setactQuestionAdd,
  getactQuestion,
  setCollection,
  setActivitylike,
  setCancelSignUp,
} from "@api/active";
import { getMyInfo, setuserfollowAdd } from "@api/home";
import {pathLoac} from "@config";
import {isValidUrl, markdownToHtml} from "@utils/markdownUtils";
export default {
  components: {
    invitation,
    summarys,
    discuss,
  },
  watch:{

  },
  data() {
    return {
      dialogVisible: false, //回复弹框
      timestamp: Date.now() / 1000,
      form: {
        taqa_content: "",
        is_expert: [10],
      },
      userinfo: [],

      flog: 1,
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      dataInfo: {},

      // 问题研讨
      discussData: [],

      currLanguage: "cn",
      // 是否是英文版
      currentLanguage: "cn",

      id: 0,

      route_query:{},// 路由访问query参数

      previewHtml: '',
      dialogVisibleLink: false,  // 控制 Dialog 显示
      linkUrl: '',           // 存储用户输入的链接
      linkType:1,
      linkToContent:"",
    };
  },
  computed: {
    userId() {
      return this.$route.params.id; // 获取路由参数
    },
  },
  created(){
    this.route_query = {...this.$route.query}
  },
  mounted() {
    // 设置默认的顶部菜单背景色
    this.$bus.$emit("changeNavbg", "rgba(255, 255, 255, 1);");
    console.log('pc preivew')
    this.getData();
    this.getCurrUserData();
    let Language = localStorage.getItem("currentLanguage"); // 获取本地语言
    this.currLanguage = Language && Language !== "zh";
    setTimeout(() => {
      window._bd_share_main.init();
      const loginMsg = localStorage.getItem(`activity_${Language}_login_msg`);
      if (loginMsg) {
        localStorage.removeItem(`activity_${Language}_login_msg`);
        this.$message({
          message: loginMsg,
          type: "success",
          customClass: "mt-60", // 添加自定义类
        });
      }
    }, 100);
  },

  destroyed() {
    window._bd_share_main.init();
  },

  methods: {
    openLinkDialog(type) {
      this.linkUrl = '';
      this.linkType = type; // 保存类型
      this.dialogVisibleLink = true; // 打开 Dialog
    },
    insertLink(type) {
      const url = this.linkUrl;
      if (url == '') {
        this.$message.warning(this.$t('请输入链接地址'));
        return;
      }
      if (url) {
        if (!isValidUrl(url)) {
          this.$message.warning(this.$t('请输入正确的链接地址'));
          return;
        }
        // 自动提取域名作为显示文本
        try {
          const urlObj = new URL(url);
        } catch (e) {
          // 不是完整URL则保持原样
        }
        // 插入Markdown格式链接
        const markdownLink = `${url}`;
        this.form.taqa_content = this.insertAtCursor(this.form.taqa_content, markdownLink,this.linkType);

      }
    },

    // 在光标位置插入文本
    insertAtCursor(text, insertText, type) {
      // 获取正确的输入组件
      const inputComponent = this.$refs.textareaRef;

      // 获取原生 textarea 元素
      let textarea = null;
      if (inputComponent && inputComponent.$refs && inputComponent.$refs.textarea) {
        textarea = inputComponent.$refs.textarea;
      }
      // 如果没有获取到 textarea，直接返回原始文本
      if (!textarea) {
        console.error("无法获取 textarea 元素");
        return text;
      }
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const insertTextLink = ` ${insertText} `;
      // 更新文本
      const newText = text.substring(0, start) + insertTextLink + text.substring(end);
      // 更新光标位置
      this.$nextTick(() => {
        textarea.selectionStart = start + insertTextLink.length;
        textarea.selectionEnd = start + insertTextLink.length;
        textarea.focus();
      });
      this.linkUrl = '';
      this.dialogVisibleLink = false;
      return newText;
    },
    async handleReplyLink() {
      if (!this.form.taqa_content.trim()) {
        this.$message.warning(this.$t('请输入内容'));
        return;
      }
      this.replyLoading = true;
      try {
        // 生成预览
        this.previewHtml = markdownToHtml(this.form.taqa_content);

        // console.log(this.previewHtml)
        // return false;
        this.form.taqa_content = this.previewHtml;
        // this.textarea = this.previewHtml
        this.handelSubPer()
        this.previewHtml = '';
      } catch (error) {
        console.error('回复失败:', error);
        this.$message.error(error.message || this.$t('操作失败'));
      } finally {
        this.replyLoading = false;
      }
    },

    handleCloseLink(){
      this.dialogVisibleLink = false; // 打开 Dialog
    },
    handleDownload(item) {
      const userId = this.userId;
      let user_info = this.userinfo;
      if (user_info.length == 0) {
        let str = "/protal";
        let lang = "/cn";

        let Language = localStorage.getItem('currentLanguage');  //获取本地语言
        if (Language && Language != 'zh') {
          str = "/protal_" + Language;
          lang = "/en";
        }

        const url = lang + '/login?callback='+lang+'/activity/info/'+userId; // 你想要跳转的 URL
        window.open(url);
        return false;
      }
      const url = `/protal/download/downAnnex?content_id=${userId}&att_id=${item.att_id}&type=10`;
      // 创建一个临时的链接元素
      const a = document.createElement('a');
      a.href = url; // 设置链接地址
      a.download = ''; // 可选：设置下载文件的名称
      document.body.appendChild(a); // 将链接添加到文档中
      a.click(); // 触发点击事件
      document.body.removeChild(a); // 下载后移除链接
    },

    closeDialog() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.form = {
          taqa_content: "",
          is_expert: [10],
        };
      }, 200);
    },

    // 关注
    async handlePostSubmitted(id) {
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
    },

    handleOpenperson(item) {
      this.$refs.avatarDialog.openModal();
      this.id = item.user_id;
    },
    async getCurrUserData() {
      let res = await getMyInfo();
      if (res.status == 200) {
        this.userinfo = res.data;
      }
    },

    handleImageError() {
      return true;
    },

    // 分享
    handleSearch() {
      let str = "/cn";
      let Language = localStorage.getItem("currentLanguage"); //获取本地语言
      if (Language && Language != "zh") {
        this.currentLanguage = Language;
      }
    },

    // 面包屑导航跳转
    handleLink(path) {
      let str = "/cn";
      let Language = localStorage.getItem("currentLanguage"); //获取本地语言
      if (Language && Language != "zh") {
        str = "/" + Language;
      }
      this.$router.push(str + path); // 使用编程式导航跳转到 About 页面
    },

    // 获取文件类型
    getDoc(title) {
      const filePath = title;
      const fileType = filePath.split(".").pop(); // 获取扩展名

      let png = ["png", "jpg", "bmp", "tif", "gif", "pcx", "svg", "webp"];
      let doc = ["doc", "docx", "DOC", "ODCX"];
      let ppt = ["ppt", "pptx", "pps", "ppsx", "pot", "potx", "odp", "xml"];
      let pdf = [
        "pdf",
        "pdf/a",
        "pdf/x",
        "pdf/e",
        "pdf/ua",
        "pdf/1.4",
        "pdf/1.5",
        "pdf/2.0",
      ];
      let mp4 = [
        "mp4",
        "mkv",
        "avi",
        "mov",
        "wmv",
        "flv",
        "webm",
        "mpeg",
        "mpg",
        "3gp",
        "mp3",
        "wav",
        "aac",
        "flac",
        "ogg",
        "wma",
        "m4a",
        "aiff",
        "opus",
      ];
      let txt = [
        "txt",
        "csv",
        "log",
        "md",
        "xml",
        "json",
        "html",
        "yaml",
        "ini",
        "tex",
      ];
      let excel = ["xls", "xlsx", "xlsm", "xlsb", "csv", "txt", "xml", "ods"];

      let typePath = "default";
      if (png.includes(fileType)) {
        typePath = "png";
      } else if (doc.includes(fileType)) {
        typePath = "doc";
      } else if (ppt.includes(fileType)) {
        typePath = "ppt";
      } else if (pdf.includes(fileType)) {
        typePath = "pdf";
      } else if (mp4.includes(fileType)) {
        typePath = "mp4";
      } else if (txt.includes(fileType)) {
        typePath = "txt";
      } else if (excel.includes(fileType)) {
        typePath = "excel";
      } else {
        typePath = "default";
      }

      return require("@/assets/images/file/" + typePath + ".png");
    },

    // 点赞
    async handleGive() {
      let res = await setActivitylike({ ta_id: this.userId });
      this.getData();
    },

    // 收藏
    async handleCollection() {
      let res = await setCollection({ ta_id: this.userId });
      this.getData();
    },
    async handelSubPer() {
      if (this.form.taqa_content.replace(/ /g, "") == "") {
        this.$message({
          message: this.$t("请填写正确的回复内容"),
          type: "error",
          customClass: "mt-60", // 添加自定义类
        });
        return false;
      }

      if (this.userinfo.user_expert == 20) this.form.is_expert[0] = 20;
      this.form.is_expert =
        this.form.is_expert.length > 0 ? this.form.is_expert[0] : "";

      // 立即提问
      let res = await setactQuestionAdd({ ...this.form, ta_id: this.userId });
      if (res.status == 200) {
        this.$message({
          message: res.data.msg,
          type: "success",
          customClass: "mt-60", // 添加自定义类
        });
      }

      this.dialogVisible = false;
      this.form = {
        taqa_content: "",
        is_expert: [10],
      };
      this.getData();
    },

    handleOpenQu() {
      this.dialogVisible = true;
    },

    // 取消报名
    async handleCancelSignUp() {
      let res = await setCancelSignUp({ ta_id: this.userId });
      if (res.status == 200) {
        this.$message({
          message: res.msg,
          type: "success",
          customClass: "mt-60", // 添加自定义类
        });
      }
      this.getData();
    },

    // 立即报名
    async handleSignUp() {
      // setSignUp
      // let res = await setSignUp({ ta_id: this.userId });
      // if (res.status == 200) {
      //   this.$message({
      //     message: res.msg,
      //     type: "success",
      //     customClass: "mt-60", // 添加自定义类
      //   });
      // }
      // this.getData();
      this.goSignregist();
      
    },
    goSignregist(item) {
        let str = '/cn';
        let Language = localStorage.getItem('currentLanguage');  //获取本地语言
        if (Language && Language != 'zh') {
            str = '/' + Language;
        }
        let target={}
        // 判断是否是精英赛
        target = this.$router.resolve(str + '/signregist/list/' + this.userId +'/1/1?callback='+str+'/activity/info/' + this.userId)
        window.open(target.href, '_blank');
    },
    // 下载资料
    async handledownload(item) {
      // let obj = {
      //     content_id: this.userId,
      //     att_id: item.att_id,
      //     type: 10,
      // }
      // let res = await getdownloaddownAnnex(obj);
      // let iframe = document.createElement('iframe');
      //     iframe.src = res.data.full_file_url;
      //     iframe.style = "display:none";
      //     document.body.appendChild(iframe);
    },
    async getData() {
      let res1 = await getactQuestion({ 
        id: this.userId,
        is_preview:this.route_query.is_preview?this.route_query.is_preview:0,
       });
      if (res1.status == 200) {
        this.discussData = res1.data;
      }
      let res2 = await getactivityInfo({ id: this.userId,...this.route_query });
      if (res2.status == 200) {
        this.dataInfo = res2.data;
      }
      console.log("活动详情接口请求");
    },
  },
};
</script>

<style lang="scss" scoped>
.is-admin{
  .activeinfo-box{
    padding: 0;
    margin-top: 0;
  }
  .control-mask{
    position: relative;
    &::after{
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 500;
    }
  }
}
.tpsn_status_box {
  position: absolute;
  right: 190px;
  top: 125px;

  img {
    margin-right: 6px;
  }
}

.share-box > .bdsharebuttonbox {
  & > a::after {
    width: 100%;
    height: 24px;
    content: "";
    font-family: "iconfont";
    display: inline-block;
    color: #040a16;
    font-size: 16px;
    text-align: left;
    position: absolute;
    left: 0;
    top: 0px;
  }
}

.bdsharebuttonbox {
  position: relative;
  // top: 3px;

  .bds_more {
    padding-left: 0;
    background-image: none;
    margin: 0;
    height: 21px;
    line-height: 21px;
  }

  .sharewx-link {
    width: 120px;
    background-color: #fff;
    border-radius: 6px;
    padding: 12px;
    box-shadow: 6px 10px 20px rgba(0, 0, 0, 0.2);
    left: -6px;
    top: -88px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.36s;

    a {
      padding-left: 22px;
    }

    a:hover {
      color: #b7251e;
    }
  }
}

.share-box .share-box:hover {
  .sharewx-link {
    left: 0px;
    top: -88px;
    opacity: 1;
    visibility: visible;
  }
}

::v-deep() {
  .el-radio__inner {
    border-radius: 4px;
  }

  .el-dialog__header {
    padding: 28px 32px 0;
  }

  .el-dialog__headerbtn {
    display: none;
  }

  .el-dialog__body {
    padding: 20px 32px 16px;
  }

  .el-dialog {
    border-radius: 8px;
  }

  .el-dialog__header .el-dialog__title {
    font-size: 18px;
    font-family: "微软雅黑";
  }

  .dialog-footer {
    .btn1,
    .btn2 {
      min-width: 75px;
      height: 36px;
      border-radius: 30px;
      padding: 0 16px;
    }

    .btn1 {
      background-color: #ffffff;
      border: 1px solid #ededed;
    }

    .btn2 {
      background-color: #d64f31;
      border: none;
    }

    .el-button + .el-button {
      margin-left: 24px;
    }
  }
}

.reply-person {
  min-height: 180px;
  background-color: #f8f8f8;
  padding: 16px;
  border-radius: 4px;

  ::v-deep() {
    .el-textarea__inner {
      border: none;
      padding: 0;
      background-color: transparent;
    }
  }
}

.mt-60 {
  margin-top: 60px !important;
}

.downAnnex-list {
  width: calc(33.33% - 22px);
  min-width: 440px;
  height: 80px;
  border: 1px solid rgb(223, 223, 223);
  border-radius: 8px;
  padding: 0 12px;
  margin-right: 22px;
  margin-bottom: 16px;

  // &:nth-child(3n) {
  //   margin-right: 0;
  // }

  &:hover {
    background: rgb(245, 246, 248);

    .righ-box .btns a {
      display: inline-block;
    }
  }

  .righ-box {
    margin-left: 8px;

    .btns a {
      cursor: pointer;
      border: none;
      outline: none;
      background-color: transparent;
      color: rgb(0, 103, 209);
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      display: none;
    }

    .size {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      margin-top: 8px;

      a:hover {
        color: #b7251e;
      }
    }
  }

  .title {
    color: rgb(25, 25, 25);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
}

.content-html {
  color: rgb(25, 25, 25);
  font-size: 16px;
  font-weight: 400;
  line-height: 32px;

  img {
    max-width: 100%;
  }

  p {
    text-indent: 2em;
  }
}

.discuss-box {
  margin-top: 20px;
  min-height: 468px;
  background-color: #ffffff;
  padding: 0 80px;
}

.content-box {
  margin-top: 35px;
  min-height: 660px;

  .null-data {
    height: 576px;

    p {
      color: rgb(119, 119, 119);
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      margin-top: 7px;
    }
  }
}

.tabs {
  margin-top: 40px;

  .list {
    position: relative;
    color: rgb(25, 25, 25);
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    margin-right: 30px;
    cursor: pointer;
    font-family: "harmonyos";
    transition: all 0.2s;

    &:hover {
      font-weight: 600;
    }

    &.active {
      font-weight: 600;

      &::after {
        content: "";
        display: block;
        width: 28px;
        height: 3px;
        border-radius: 4px;
        background: rgb(183, 37, 30);
        position: absolute;
        bottom: -5px;
        left: 50%;
        margin-left: -14px;
      }
    }
  }
}

.bread-bar {
  .li {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #939393;
    margin-right: 2px;

    &.active {
      color: #191919;
    }

    &::after {
      content: "/";
      display: inline-block;
      margin-left: 3px;
    }

    &:last-child {
      &::after {
        content: "";
      }
    }
  }
}

.info-box {
  height: 300px;
  margin-top: 15px;

  .left-box {
    // width: 32.61%;
    max-width: 46%;
    // min-width: 436px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .right-box {
    border-radius: 4px;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.08);
    background: rgb(255, 255, 255);
    margin-left: 20px;
    padding: 24px;
    position: relative;

    .title {
      color: rgb(25, 25, 25);
      font-size: 24px;
      font-weight: 700;
      line-height: 36px;
    }
  }

  .list-box {
    margin-top: 16px;

    .li {
      color: rgb(25, 25, 25);
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      margin-bottom: 8px;

      img {
        margin-right: 5.33px;
      }
    }

    .li:last-child {
      margin-bottom: 0;
    }
  }

  .avarat-box {
    padding-left: 8px;

    ::v-deep() {
      .el-avatar {
        margin-left: -8px;
      }
    }
  }

  .r-box {
    .code-box {
      width: 115px;
      min-height: 136px;
      border-radius: 4px;
      padding-bottom: 10px;
      border: 1px solid #dadcde;
    }
  }

  .b-box {
    .btn1 {
      min-width: 140px;
      height: 48px;
      border-radius: 40px;
      background: rgb(183, 37, 30);
      padding: 0 16px;

      &:hover {
        opacity: 0.8;
      }
    }

    .btn2 {
      min-width: 140px;
      max-width: 150px;
      height: 48px;
      border-radius: 40px;
      background: rgb(255, 237, 235);
      padding: 0 16px;
      border: none;
      color: rgb(183, 37, 30);

      &:hover {
        opacity: 0.8;
      }

      p {
        color: #777777;
        margin-top: 4px;
      }
    }

    .share-box {
      .cup {
        cursor: pointer;
      }

      .c-them {
        .iconfont {
          color: #b7251e;
        }
      }

      & > div {
        margin-right: 21px;
      }

      .text {
        color: #777777;
        font-size: 14px;
        font-weight: 400;
        line-height: 23px;
      }

      .iconfont {
        color: #777777;
        margin-right: 5px;
      }
    }
  }
}

.share-box .avarat-box{
display: none;
margin-top: 0 !important;
padding-top: 2px !important;
margin-right: 6px !important;
}

@media (max-width: 1440px) {
  .share-box .avarat-box{
    display: flex;
  }
  .l-box > .avarat-box{
    display: none;
  }
  .info-box{
    height: 218px;
    .b-box{
      margin-top: 0px !important;
    }

  }
  .info-box .r-box .code-box{
    width: 88px;
    min-height: 106px;
    padding-bottom: 4px;
    position: relative;
    top: -14px;
    p{
      font-size: 10px !important;
    }
  }
}

.activeinfo-box {
  padding: 40px 80px 40px;
  margin-top: 60px;
  background-color: #ffffff;
}
</style>